import { ENDPOINTS } from '../consts';
import { AbstractApi } from '../../abstract-api';
import { UserSettings, PatchUserSettings } from '../types/user-settings.types';

export class UserSettingsApi extends AbstractApi {
  async get(): Promise<UserSettings> {
    const axios = await this.axios();
    const { data } = await axios.get<UserSettings>(ENDPOINTS.USER.SETTINGS);
    return data;
  }

  async patch(userSettings: PatchUserSettings): Promise<UserSettings> {
    const axios = await this.axios();
    const { data } = await axios.patch<UserSettings>(ENDPOINTS.USER.SETTINGS, userSettings);
    return data;
  }
}
